import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    // create
    createUserStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    createUserSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    createUserFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetCreateUserState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
    // update
    updateUserStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    updateUserSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    updateUserFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetUpdateUserState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
    // block
    blockUserStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    blockUserSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    blockUserFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetBlockUserState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
    //delete
    deleteUserStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    deleteUserSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    deleteUserFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetDeleteUserState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  createUserStart,
  createUserSuccess,
  createUserFailure,
  updateUserStart,
  updateUserSuccess,
  updateUserFailure,
  blockUserStart,
  blockUserSuccess,
  blockUserFailure,
  deleteUserStart,
  deleteUserSuccess,
  deleteUserFailure,
  resetBlockUserState,
  resetUpdateUserState,
  resetCreateUserState,
  resetDeleteUserState,
} = userSlice.actions;

export default userSlice.reducer;
